export default [
  {
    path: '/directorio',
    name: 'directorio',
    component: () =>
      import(/* webpackChunkName: "index" */ './index.vue'),
  },
];
